import { Box, Button, ButtonBase, Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledButtonProps {
  isfilteractive: 'true' | 'false';
}

export const StyledButton = styled(ButtonBase)<StyledButtonProps>(
  ({ isfilteractive, theme }) => ({
    padding: '9px',
    marginRight: '-10px',
    borderRadius: '50%',
    cursor: 'pointer',
    color: isfilteractive === 'true' ? theme.palette.secondary.main : 'inherit',
  })
);

export const StyledDialog = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '4px',
    backgroundColor: '#FAFCFF',
    minHeight: 'fit-content',
    padding: '50px 40px 40px',
    margin: '16px 0',
    width: '600px',
    [theme.breakpoints.up('xl')]: {
      width: '800px',
    },
  },
}));

export const SectionBox = styled(Box)(() => ({
  marginBottom: '40px',
}));

export const SpaceBetweenBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '20px',
  marginTop: '40px',
}));

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  gap: '20px',
}));

export const BorderButton = styled(Button)(({ theme }) => ({
  width: '156px',
  border: `1px solid ${theme.palette.secondary.main}`,
  backgroundColor: '#FAFCFF',
  fontWeight: '700',
  color: theme.palette.secondary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
  },
  '&:active': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    backgroundColor: '#FAFCFF',
    color: theme.palette.secondary.main,
  },
}));

export const SubmitButton = styled(Button)(() => ({
  width: '156px',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
